import UserAuth from "@features/UserAuth";
import "../style/Auth.scss";

const AuthPage = () => {
  return (
    <div className="auth-page">
      <div className="auth-page__left">
        <img src="/img/logo.png" alt="logo" />
      </div>
      <div className="auth-page__right">
        <UserAuth />
      </div>
    </div>
  );
};

export default AuthPage;
